import { faFilter } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { FC, useRef } from "react"
import { Form, Overlay, Popover } from "react-bootstrap"

const FilterDropdown: FC<{
  id: string
  filters: Record<string, any>
  setFilters: React.Dispatch<React.SetStateAction<Record<string, any>>>
  options: {label: string; key: string; values: string[]}[]
  hasActiveFilter: boolean
  openFilterKey: string | null
  setOpenFilterKey: React.Dispatch<React.SetStateAction<string | null>>
  // Optional function to format the displayed option label
  formatOptionLabel?: (val: string) => string
}> = ({id, filters, setFilters, options, hasActiveFilter, openFilterKey, setOpenFilterKey, formatOptionLabel}) => {
  const iconRef = useRef<HTMLSpanElement | null>(null)
  console.log()

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>, key: string) => {
    setFilters((prev) => ({
      ...prev,
      [key]: e.target.value,
    }))
  }

  const togglePopover = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    setOpenFilterKey((prev) => (prev === id ? null : id))
  }

  const isOpen = openFilterKey === id

  return (
    <>
      <span
        ref={iconRef}
        style={{
          cursor: 'pointer',
          color: hasActiveFilter ? 'blue' : 'darkgrey',
        }}
        onClick={togglePopover}
      >
        <FontAwesomeIcon icon={faFilter} />
      </span>

      <Overlay
        target={iconRef.current}
        show={isOpen}
        placement='bottom-end'
        rootClose
        onHide={() => setOpenFilterKey(null)}
      >
        <Popover
          id='filter-popover'
          className='p-2'
          style={{minWidth: '220px'}}
          onClick={(e) => e.stopPropagation()}
        >
          <Popover.Body>
            {options.map(({label, key, values}) => (
              <Form.Group key={key} className='mb-2'>
                <Form.Label className='mb-1'>{label}</Form.Label>
                <Form.Select
                  size='sm'
                  value={filters[key] || ''}
                  onChange={(e) => handleSelectChange(e, key)}
                >
                  <option value=''>All</option>
                  {values.map((val, idx) => (
                    <option key={idx} value={val}>
                      {formatOptionLabel ? formatOptionLabel(val) : val}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            ))}
          </Popover.Body>
        </Popover>
      </Overlay>
    </>
  )
}

export default FilterDropdown;